import styled from "@emotion/styled";
import React from "react";
import jeftinijeLogo from "src/assets/images/logo-jeftinije.svg";
import { i18n } from "src/common";
import { colors } from "src/theme";

const BannerStyle = styled.div({
  display: 'flex',
  // Full content width. `box-sizing: border-box` is global, so the padding sits inside.
  width: '100%',
  padding: '4px 8px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  borderRadius: 4,
  background: colors.partnerBannerBg,
  color: colors.text7,
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '16px',
});

const LogoLinkStyle = styled.a({
  display: 'flex',
  flexShrink: 0,
});

// Drawn at its own 62x17, and never squashed: if the copy runs long the text wraps
// and the wordmark stays intact. Its glyphs are filled white (bar the orange `!`),
// so it only works on a dark banner ground.
const LogoStyle = styled.img({
  display: 'block',
  width: 62,
  height: 17,
});

/** Partner branding per `code`. A partner missing from here gets no banner. */
const partners: Record<string, { logo: string; href: string }> = {
  jeftinije: { logo: jeftinijeLogo, href: 'https://www.jeftinije.hr/' },
};

interface PartnerBannerProps {
  /** Partner `code` from the SO. Renders nothing for partners with no co-branding. */
  code?: string;
  name?: string;
}

export const PartnerBanner: React.FC<PartnerBannerProps> = ({ code, name }) => {
  const partner = code ? partners[code] : undefined;
  if (!partner) return null;

  return (
    <BannerStyle>
      <span>{i18n.t('components.other.partnerBanner.prefix')}</span>
      {/* New tab on purpose: the customer is mid-funnel, so leaving in place would
          cost them the offers they came for. */}
      <LogoLinkStyle href={partner.href} target="_blank" rel="noopener noreferrer">
        <LogoStyle src={partner.logo} alt={name ?? code} />
      </LogoLinkStyle>
      <span>{i18n.t('components.other.partnerBanner.suffix')}</span>
    </BannerStyle>
  );
};
